import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon } from '@heroicons/react/24/outline';

const motivationalMessages = [
  'Contact us if you need more time!',
];

export default function ExpiryLinkTimer({
  sessionEndsAt,
}: {
  sessionEndsAt: number;
}) {
  const [timeRemaining, setTimeRemaining] = React.useState<string>('');
  const [message, setMessage] = React.useState('');

  React.useEffect(() => {
    const updateTime = () => {
      const now = Date.now();
      const diff = sessionEndsAt - now;

      if (diff <= 0) {
        setTimeRemaining('0h 0m 0s');
        return;
      }

      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      setTimeRemaining(`${hours}h ${minutes}m ${seconds}s`);
    };

    const timer = setInterval(updateTime, 1000);
    updateTime();

    return () => clearInterval(timer);
  }, [sessionEndsAt]);

  React.useEffect(() => {
    const randomMessage =
      motivationalMessages[
        Math.floor(Math.random() * motivationalMessages.length)
      ];
    setMessage(randomMessage);
  }, []);

  if (!timeRemaining) return null;

  return (
    <motion.div
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      className="bg-gradient-to-r from-primary/10 to-primary/5 border-b border-primary/10"
    >
      <div className="mx-auto max-w-7xl px-4 py-3 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between flex-wrap">
          <div className="flex items-center">
            <ClockIcon className="h-5 w-5 text-primary-600 mr-2" />
            <p className="font-medium text-primary-800">
              Session expires in {timeRemaining}
            </p>
          </div>
          <p className="text-sm text-primary-700 hidden sm:block">{message}</p>
        </div>
      </div>
    </motion.div>
  );
}
